import React, { memo } from "react";

import faTrash from "@fortawesome/fontawesome-free-solid/faTrashAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ButtonPickerTime = memo(
  ({ isUpdateInProcess = true, removeData, addTimeIsInProgress }) => {
    return (
      <div
        className={`container-button-picker-time ${
          isUpdateInProcess ? "disabled-button-time-picker" : ""
        }`}
      >
        <FontAwesomeIcon
          className={`admin-fa-icon icon-remove-time ${
            isUpdateInProcess || addTimeIsInProgress ? "disabled-button" : ""
          }`}
          onClick={
            isUpdateInProcess || addTimeIsInProgress ? null : e => removeData(e)
          }
          icon={faTrash}
        />
      </div>
    );
  }
);

export default ButtonPickerTime;
